import React, {useState} from 'react';
import {Col, Form, Input, Row} from 'antd';
import Button from "../../common/Button/Button";

import './styles.scss';

import {VendorFormTypes} from "./VendorFormTypes";
import cx from "classnames";
import {ArrowRightOutlined, UserOutlined} from '@ant-design/icons';
import FormSectionHeader from "../../common/FormSectionHeader/FormSectionHeader";

interface Props {
    onSubmit: (values: any) => void
    applyDrawerStyles?: boolean,
}

function VendorForm(props: Props) {
    const {onSubmit, applyDrawerStyles} = props;
    const [form] = Form.useForm();
    // eslint-disable-next-line
    const [valuesForm, setValuesForm] = useState({});
    const [submittingForm, setSubmittingForm] = useState(false);

    async function onSubmitClick() {
        if (submittingForm) return false;
        setSubmittingForm(true);
        try {
            let valid = await form.validateFields();
            if (!valid.errorFields && onSubmit) {
                let values = form.getFieldsValue();
                await onSubmit(values);
            }
        } catch (e) {

        }
        setSubmittingForm(false);
    }

    function onValuesChange(v) {
        setValuesForm(v)
    }

    function renderButton() {
        if (applyDrawerStyles) {
            return (
                <div className='form-stickied-footer'>
                    <Button onClick={onSubmitClick} htmlType='submit' loading={submittingForm}
                            icon={<ArrowRightOutlined/>} iconPosition='right'>
                        Create Vendor
                    </Button>
                </div>
            )
        } else {
            return (
                <Button onClick={onSubmitClick} htmlType='submit' loading={submittingForm}>
                    Create Vendor
                </Button>
            )
        }
    }

    let initialValues = {}

    return (
        <Form className={cx('vendors-form', {'as-drawer': applyDrawerStyles})} name="vendors-form" layout='vertical'
              form={form} initialValues={initialValues}
              autoComplete="off" preserve={false} onValuesChange={onValuesChange} requiredMark='optional'>
            <div className='vendors-form-content'>
                <Form.Item label='Vendor Name' name={VendorFormTypes.Name}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <Input size='large'/>
                </Form.Item>
                <FormSectionHeader text='Point of Contact' icon={<UserOutlined/>} help="A point of contact is required. Upon Vendor creation, an invitation will be sent to the point of contact's email."/>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label='First Name' name={VendorFormTypes.PointOfContactFirstName}
                                   rules={[{required: true, message: 'This field is required.'}]}>
                            <Input size='large'/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label='Last Name' name={VendorFormTypes.PointOfContactLastName}
                                   rules={[{required: true, message: 'This field is required.'}]}>
                            <Input size='large'/>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item label='Email' name={VendorFormTypes.PointOfContactEmail}
                           rules={[{required: true, message: 'This field is required and needs to be a valid email.', type: 'email'}]}>
                    <Input size='large'/>
                </Form.Item>
            </div>
            {renderButton()}
        </Form>
    );
}

export default VendorForm;